import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { DataService } from '../../../services/data.service';
import { InfotooltipComponent } from '../../../commonUI/infotooltip/infotooltip.component';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { SourceType } from 'src/app/models/sourcetype';
import { FormService } from 'src/app/services/form';
import { Constants } from 'src/app/core/constants';
import { LocalstorageService } from 'src/app/services/localstorage.service';
import { ToastService } from 'src/app/services/toaster/toaster.service';
import { NGXLogger } from 'ngx-logger';
import { AppSettings } from 'src/app/app.settings';
import { AddSourceTypeDTO } from '../../../models/addsourcetype-dto';
import { BasePageWithToolTip } from '../../../core/basepages/basepagewith-tooltip';
@Component({
  selector: 'app-pe-addsourcetype',
  templateUrl: './pe-addsourcetype.component.html',
  styleUrls: ['./pe-addsourcetype.component.scss']
})
export class PeAddsourcetypeComponent extends BasePageWithToolTip implements OnInit {
  addSourceTypeForm: FormGroup;
  childControlTooltipText: string = '';
  IsLevelChecked: boolean = false;
  parentSourceTypeList: SourceType[];
  @Output() formUpdated = new EventEmitter<number>();

  public formErrorsAddSourceType = {
    Id: '',
    Name: '',
    Description: '',
    IsChildLevel: '',
    ParentSourceId: ''
  };

  constructor(
    private dataService: DataService,
    private fb: FormBuilder,
    localstorageService: LocalstorageService,
    private toastService: ToastService,
    private formService: FormService,
    appSettings: AppSettings,
    logger: NGXLogger) {
      super();
    this.addSourceTypeForm = this.fb.group({
        Id: [
          null,
          Validators.compose([
            Validators.required,
          ]),
        ],
        Name: [
          null,
          Validators.compose([
            Validators.required,
            Validators.maxLength(50)
          ]),
        ],
        Description: [
          null,
          Validators.compose([
            Validators.required,
            Validators.maxLength(100)
          ]),
        ],
      IsChildLevel: [false, [Validators.required]],
      ParentSourceId: [null]
    })
  }

  /*
  TMS-14250 Add new screen for adding sourcetypes for warehouse locations
  Add Parent source information
  Add Parent-child mapping information
  only accessible to admins
  */
  ngOnInit() {
    this.addSourceTypeForm.valueChanges.subscribe(data => {
      this.formErrorsAddSourceType = this.formService.validateForm(
        this.addSourceTypeForm,
        this.formErrorsAddSourceType,
        true
      );
      this.formUpdated.emit();
    });
  }

  refreshToolTipText(code: string) {
    this.childControlTooltipText = Constants[code];
  }

  IsLevelChanged(event) {
    this.IsLevelChecked = event.checked;
    this.dataService.getParentSourceTypes().subscribe((response: any) => {
      if (response && response.Data != null) {
        this.parentSourceTypeList = response.Data;
      }
    });
  }

  addSourceType() {
    const sourceTypeDto: AddSourceTypeDTO = this.createAddSourceTypeDTO(this.addSourceTypeForm);
    this.dataService.
      addSourceTypeforParentOrChildBusinessLocation(sourceTypeDto)
      .subscribe((response: any) => {
        this.toastService.success('Business location created successfully', true);
      });
    this.addSourceTypeForm.reset();
  }

  /*
  Function which will construct request object based on the incoming form values 
 */
  createAddSourceTypeDTO(g: FormGroup): AddSourceTypeDTO {
    const addSourceTypeDTO: AddSourceTypeDTO = new AddSourceTypeDTO();
    addSourceTypeDTO.Id = g.controls['Id'].value;
    addSourceTypeDTO.Name = g.controls['Name'].value;
    addSourceTypeDTO.Description = g.controls['Description'].value;
    if (g.controls['IsChildLevel'].value) {
      addSourceTypeDTO.IsChildLevel = 1;
      addSourceTypeDTO.ParentSourceTypeId = g.controls['ParentSourceId'].value;
    }
    else {
      addSourceTypeDTO.IsChildLevel = 0;
      addSourceTypeDTO.ParentSourceTypeId = 0;
    }
    return addSourceTypeDTO;
  }
}

